import React from 'react'
import NextLink from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

import type { StatusPerencanaan } from 'types/kinerja-ps-pegawai'

type TugasPokokCTAProps = {
  state: StatusPerencanaan
}

const TugasPokokCTA = ({ state }: TugasPokokCTAProps) => {
  const isMulaiPerencanaan = state === 'MULAI_PERENCANAAN'
  return (
    <NextLink
      href={`${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/tugas-pokok`}
      passHref
    >
      <Button size="md" color={isMulaiPerencanaan ? 'black' : 'white'}>
        {isMulaiPerencanaan ? 'Mulai' : 'Cek'}
      </Button>
    </NextLink>
  )
}

export default TugasPokokCTA
